module.exports = __webpack_public_path__ + "static/img/pdf.0bd3f690.svg";